(function () {

    const SPRITE_URL = "https://cdn.shopify.com/s/files/1/0984/9723/3226/files/logo_sprite_300_10x12_33759eae-7156-4b05-a14b-faf9910a9289.webp?v=1782659755";

    const FRAME_SIZE = 300;
    const COLS = 10;
    const TOTAL_FRAMES = 120;
    const REST_POSITIONS = [0, 60];

    let frame = 0;
    let velocity = 0;

    let lastScroll = window.scrollY || window.pageYOffset || 0;

    function initLogoCanvas() {

        const logoImg = document.querySelector(".header__heading-logo");
        if (!logoImg) return;

        const wrapper = logoImg.closest(".header__heading-logo-wrapper") || logoImg.parentElement;
        if (!wrapper) return;

        if (wrapper.querySelector(".ddt-logo-canvas")) return;

        const canvas = document.createElement("canvas");
        canvas.className = "ddt-logo-canvas";

        const rect = logoImg.getBoundingClientRect();
        canvas.width = Math.max(1, Math.round(rect.width));
        canvas.height = Math.max(1, Math.round(rect.height));

        wrapper.appendChild(canvas);

        const ctx = canvas.getContext("2d");

        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";

        const sprite = new Image();
        sprite.src = SPRITE_URL;

        function resizeCanvas() {

            const r = logoImg.getBoundingClientRect();

            const w = Math.max(1, Math.round(r.width));
            const h = Math.max(1, Math.round(r.height));

            if (canvas.width !== w || canvas.height !== h) {
                canvas.width = w;
                canvas.height = h;

                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = "high";
            }

        }

        function shortestDelta(current, target) {

            let delta = target - current;

            while (delta > TOTAL_FRAMES / 2) delta -= TOTAL_FRAMES;
            while (delta < -TOTAL_FRAMES / 2) delta += TOTAL_FRAMES;

            return delta;
        }

        function animate() {

            resizeCanvas();

            const currentScroll = window.scrollY || window.pageYOffset || 0;
            const deltaScroll = currentScroll - lastScroll;

            velocity += deltaScroll * 0.008;
            lastScroll = currentScroll;

            frame += velocity;

            velocity *= 0.92;

            if (Math.abs(velocity) < 0.01) {
                velocity = 0;
            }

            // Retour automatique vers la position de repos la plus proche
            if (velocity === 0) {

                const current =
                    ((frame % TOTAL_FRAMES) + TOTAL_FRAMES) % TOTAL_FRAMES;

                let bestTarget = REST_POSITIONS[0];
                let bestDelta = shortestDelta(current, bestTarget);

                for (const target of REST_POSITIONS) {

                    const delta = shortestDelta(current, target);

                    if (Math.abs(delta) < Math.abs(bestDelta)) {
                        bestDelta = delta;
                        bestTarget = target;
                    }
                }

                frame += bestDelta * 0.08;
            }

            const index =
                ((Math.round(frame) % TOTAL_FRAMES) + TOTAL_FRAMES) % TOTAL_FRAMES;

            const col = index % COLS;
            const row = Math.floor(index / COLS);

            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const size = Math.min(canvas.width, canvas.height);
            const dx = (canvas.width - size) / 2;
            const dy = (canvas.height - size) / 2;

            ctx.drawImage(
                sprite,
                col * FRAME_SIZE,
                row * FRAME_SIZE,
                FRAME_SIZE,
                FRAME_SIZE,
                dx,
                dy,
                size,
                size
            );

            requestAnimationFrame(animate);

        }

        sprite.onload = function () {
            animate();
        };

    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initLogoCanvas);
    } else {
        initLogoCanvas();
    }

})();